import script from "./QuizHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizHistory.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__